import React, { Fragment, useContext } from 'react';
import { useTranslation } from 'react-i18next';

// Load layout components
import PageSpinner from '../components/layout/PageSpinner';
import DocumentsComponent from '../components/documents/DocumentsComponent';

import { GlobalContext } from '../store/Provider';

const Documents = () => {
  const { t } = useTranslation();

  const { documentsState } = useContext(GlobalContext);

  return (
    <Fragment>
      <h1>{t('documents.name')}</h1>
      {documentsState.documents.fetching ? (
        <PageSpinner msg={t('general.stillFetchingData')} />
      ) : (
        <DocumentsComponent />
      )}
    </Fragment>
  );
};

export default Documents;
